// some foolishness required to trick the webpack autoload code
window.$ = window['j' + 'Query'] = require('jquery');

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.$.ajaxSetup({
        headers: { 'X-CSRF-TOKEN': token.content },
    });

    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

require('datatables.net');
require('datatables.net-bs');
require('jquery-match-height');
require('jquery-sparkline');
require('sb-admin-2-sass/dist/js/sb-admin-2.js');

window._ = require('lodash');
window.Ladda = require('ladda');
window.palette = require('randomcolor');
window.Pickr = require('@simonwep/pickr');
window.Selectize = require('selectize');
window.toastr = require('toastr');

require('alpinejs');
require('bootstrap');
require('jasny-bootstrap/dist/js/jasny-bootstrap');
require('bootstrap-datepicker');
require('bootstrapValidator');

// include vendor stylesheets here as CSS files can't be include
// via @import in newer versions of node-sass
require('font-awesome/css/font-awesome.css');
require('bootstrap/dist/css/bootstrap.css');
require('toastr/toastr.scss');
require('selectize/dist/css/selectize.bootstrap3.css');
require('jasny-bootstrap/dist/css/jasny-bootstrap.css');
require('bootstrap-datepicker/dist/css/bootstrap-datepicker3.css');
require('bootstrapValidator/dist/css/bootstrapValidator.css');
require('@simonwep/pickr/dist/themes/nano.min.css');
require('ladda/dist/ladda-themeless.min.css');
require('sb-admin-2-sass/dist/css/sb-admin-2.css');
